// components/Spinner.js
import React from 'react';
import './Spinner.css'; // or use inline styles if preferred

const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner" />
    <p>Checking admin access...</p>
  </div>
);

export default Spinner;
